import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { AllocatedBalance, TransferAllocatedBalanceRequest } from 'src/app/models/balance';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BalanceService } from 'src/app/services/balance.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

@Component({
  selector: 'app-saldo-alocado-list',
  templateUrl: './saldo-alocado-list.component.html',
  styleUrls: ['./saldo-alocado-list.component.css']
})
export class SaldoAlocadoListComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private alertService: NewAlertService,
    private balanceService: BalanceService,
    private authenticationService: AuthenticationService,
  ) { }

  public currentUser: Auth;
  public allocatedBalances: AllocatedBalance[];
  public selectedAllocatedBalance: AllocatedBalance;

  public allocatedBalanceDebit: FormControl = new FormControl();
  public value: FormControl = new FormControl();



  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;

    this.carregarSaldos();
  }

  carregarSaldos() {
    this.balanceService.getAllocatedBalances(this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.allocatedBalances = response.result;
        }
        else {
          this.alertService.error(response.message);
        }
      }, error => { console.log(error.message) }
    );
  }

  goToEdit(id: number) {
    this.router.navigate([`edit/${id}`], { relativeTo: this.route.parent });
  }

  goToCreate() {
    this.router.navigate(['create'], { relativeTo: this.route.parent });
  }

  showTransferModal(content: any, item: any) {
    this.selectedAllocatedBalance = item;
    this.modalService.open(content, { centered: true });
  }
  
  showWithdrawModal(content: any, item: any) {
    this.selectedAllocatedBalance = item;
    this.modalService.open(content, { centered: true });
  }

  transferAllocatedBalance(){
    let allocatedBalanceDebit = this.allocatedBalanceDebit.value;
    const value = this.value.value;

    const gestorCedente = JSON.parse(sessionStorage.getItem('gestorCedente'));

    let transferAllocatedBalanceRequest = new TransferAllocatedBalanceRequest();
    transferAllocatedBalanceRequest.assignorGuid = this.currentUser.token.assignorGuid;
    transferAllocatedBalanceRequest.value = value;
    transferAllocatedBalanceRequest.allocatedBalanceId = this.selectedAllocatedBalance.allocatedBalanceId;
    transferAllocatedBalanceRequest.managerId = gestorCedente.gestorId;
    if(allocatedBalanceDebit === 0){
        transferAllocatedBalanceRequest.allocatedBalanceDebitId = 0
    }
    else {
        transferAllocatedBalanceRequest.isCurrentAccount = false;
        transferAllocatedBalanceRequest.allocatedBalanceDebitId = allocatedBalanceDebit;
    }

    this.balanceService.transferAllocatedBalance(transferAllocatedBalanceRequest).subscribe(
        response => {
            if (response.status === ApiError.Sucesso) {
              this.carregarSaldos();
              this.modalService.dismissAll();
            }
            else {
              this.alertService.error(response.message);
            }
          }, error => { console.log(error.message) }
        )
    }

  withdrawAllocatedBalance(){
    const value = this.value.value;

    const gestorCedente = JSON.parse(sessionStorage.getItem('gestorCedente'));

    let withdrawAllocatedBalanceRequest = new TransferAllocatedBalanceRequest();
    withdrawAllocatedBalanceRequest.assignorGuid = this.currentUser.token.assignorGuid;
    withdrawAllocatedBalanceRequest.value = value;
    withdrawAllocatedBalanceRequest.allocatedBalanceId = this.selectedAllocatedBalance.allocatedBalanceId;
    withdrawAllocatedBalanceRequest.managerId = gestorCedente.gestorId;    

    this.balanceService.withdrawAllocatedBalance(withdrawAllocatedBalanceRequest).subscribe(
        response => {
            if (response.status === ApiError.Sucesso) {
              this.carregarSaldos();
              this.modalService.dismissAll();
            }
            else {
              this.alertService.error(response.message);
            }
          }, error => { console.log(error.message) }
        )
    }
}
